export default [
  { code: 'fr', name: 'Français', flag: 'fr' },
  { code: 'de', name: 'Deutsch', flag: 'de' },
  { code: 'en', name: 'English', flag: 'us' },
  { code: 'it', name: 'Italiano', flag: 'it' },
  { code: 'cn', name: '中文', flag: 'cn' }
]



// WEBPACK FOOTER //
// ./src/i18n/locales.js